if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    static SELECTORS = {
      tab: '.product-tabs__tab',
      panel: '.product-tabs__panel',
    };

    static CLASSES = {
      tabActive: 'product-tabs__tab--active',
      panelHidden: 'product-tabs__panel--hidden',
    };

    static ATTRS = {
      tabIndex: 'data-tab-index',
    };

    connectedCallback () {
      this._abort = new AbortController();
      this._tabs = Array.from(this.querySelectorAll(ProductTabs.SELECTORS.tab));
      this._panels = Array.from(this.querySelectorAll(ProductTabs.SELECTORS.panel));

      this._tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          () => this._activate(tab.getAttribute(ProductTabs.ATTRS.tabIndex)),
          { signal: this._abort.signal }
        );
      });
    }

    disconnectedCallback () {
      this._abort?.abort();
    }

    _activate (index) {
      if (!index) return;

      this._tabs.forEach((tab) => {
        const isActive = tab.getAttribute(ProductTabs.ATTRS.tabIndex) === index;
        tab.classList.toggle(ProductTabs.CLASSES.tabActive, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this._panels.forEach((panel) => {
        const isActive = panel.getAttribute(ProductTabs.ATTRS.tabIndex) === index;
        panel.classList.toggle(ProductTabs.CLASSES.panelHidden, !isActive);
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
